export default {"src":"/_next/static/media/mft.2d214d30.svg","height":32,"width":32,"blurWidth":0,"blurHeight":0};